import {useMutation} from "@tanstack/react-query";
import {restoreExpedientMutationOptions} from "./restore-expedient.mutation-options";

export function useRestoreExpedient() {
  return useMutation(restoreExpedientMutationOptions());
}
